module.exports = ".table-responsive{\r\n\theight: calc(100% - 48px);\r\n}\r\n.table td, .table th{\r\n\twhite-space: pre-wrap;\r\n\tpadding: 18px 20px;\r\n}\r\n.table th,.table td.py-1{\r\n\twhite-space: nowrap;\r\n}\r\n.table td img, .table th img{\r\n\t/*margin-top: -30px;*/\r\n}\r\n.table td.pressman-opt{\r\n\twhite-space: nowrap;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/back/list/list.component.css
// module id = ./src/app/back/list/list.component.css
// module chunks = main